import { useCallback, useEffect, useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { api } from "@/lib/api";
import { AdminListings } from "@/components/admin/AdminListings";
import { LeadsList } from "@/components/admin/LeadsList";

const STATS = [
  ["buyers_pending", "Buyers awaiting review"], ["buyers_verified", "Verified buyers"], ["sellers_new", "New seller submissions"],
  ["enquiries_new", "New enquiries"], ["properties_live", "Live properties"], ["deals_completed", "Completed deals"],
];

const TABS = [
  ["buyers", "Buyers", "admin-tab-buyer-leads"], ["sellers", "Sellers", "admin-tab-seller-leads"],
  ["enquiries", "Enquiries", "admin-tab-enquiries"], ["properties", "Properties", "admin-tab-properties"],
  ["deals", "Completed deals", "admin-tab-completed-deals"],
];

export default function Admin() {
  const [stats, setStats] = useState({});
  const loadStats = useCallback(() => { api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);
  useEffect(loadStats, [loadStats]);

  return (
    <div className="max-w-7xl mx-auto px-6 sm:px-10 py-14" data-testid="admin-page">
      <p className="eyebrow">Admin desk</p>
      <h1 className="mt-3 font-display text-4xl tracking-tight">Your pipeline</h1>
      <p className="mt-2 text-sm text-[#57534E]">Only you can see client details and documents. Clients never see each other. Changing a lead's status automatically emails that client an update (private notes are never shared).</p>
      <div className="mt-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-px bg-[#E4E1D9] border border-[#E4E1D9]">
        {STATS.map(([k, label]) => (
          <div key={k} className="bg-white p-5" data-testid={`admin-stat-${k}`}>
            <p className="font-display text-3xl">{stats[k] ?? "–"}</p>
            <p className="mt-1 font-plex text-[11px] uppercase tracking-wider text-[#847F77]">{label}</p>
          </div>
        ))}
      </div>
      <Tabs defaultValue="buyers" className="mt-12">
        <TabsList className="bg-transparent p-0 h-auto flex flex-wrap justify-start gap-2 border-b border-[#E4E1D9] w-full rounded-none">
          {TABS.map(([v, label, tid]) => (
            <TabsTrigger key={v} value={v} data-testid={tid}
              className="rounded-none px-4 py-3 border-b-2 border-transparent data-[state=active]:border-[#9F7E44] data-[state=active]:shadow-none data-[state=active]:bg-transparent">
              {label}
            </TabsTrigger>
          ))}
        </TabsList>
        {["buyers", "sellers", "enquiries"].map((k) => (
          <TabsContent key={k} value={k} className="mt-8"><LeadsList kind={k} onChange={loadStats} /></TabsContent>
        ))}
        <TabsContent value="properties" className="mt-8"><AdminListings kind="properties" onChange={loadStats} /></TabsContent>
        <TabsContent value="deals" className="mt-8"><AdminListings kind="deals" onChange={loadStats} /></TabsContent>
      </Tabs>
    </div>
  );
}
